/* @flow */
const prefix = str => `station/companies/${str}`;

export const FETCH = prefix('FETCH');
export const FETCH_SUCCESS = prefix('FETCH_SUCCESS');
export const FETCH_FAILURE = prefix('FETCH_FAILURE');

export const SAVE = prefix('SAVE');
export const SAVE_SUCCESS = prefix('SAVE_SUCCESS');
export const SAVE_FAILURE = prefix('SAVE_FAILURE');

export const DELETE = prefix('DELETE');
export const DELETE_SUCCESS = prefix('DELETE_SUCCESS');
export const DELETE_FAILURE = prefix('DELETE_FAILURE');

// Action types for fetching rate limits / request quotas
export const FETCH_QUOTA = prefix('FETCH_QUOTA');
export const FETCH_QUOTA_SUCCESS = prefix('FETCH_QUOTA_SUCCESS');
export const FETCH_QUOTA_FAILURE = prefix('FETCH_QUOTA_FAILURE');

export const SAVE_QUOTA = prefix('SAVE_QUOTA');
export const SAVE_QUOTA_SUCCESS = prefix('SAVE_QUOTA_SUCCESS');
export const SAVE_QUOTA_FAILURE = prefix('SAVE_QUOTA_FAILURE');

export const RESET_QUOTA = prefix('RESET_QUOTA');
export const RESET_QUOTA_SUCCESS = prefix('RESET_QUOTA_SUCCESS');
export const RESET_QUOTA_FAILURE = prefix('RESET_QUOTA_FAILURE');

export const SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');



// WEBPACK FOOTER //
// ./src/app/modules/companies/action-types.js